module.exports = __webpack_public_path__ + "static/media/suitcase-walking.248923b4.svg";